var map = {
	"./Android.svg": "6a70",
	"./Bethesda.svg": "e36a",
	"./blizzard.svg": "7a9e",
	"./ea.svg": "5739",
	"./epic.svg": "8bf1",
	"./heybox.svg": "a382",
	"./iOS.svg": "72d3",
	"./microsoft.svg": "aec4",
	"./origin.svg": "3c8e",
	"./ps4.svg": "912e",
	"./rocketstar.svg": "a122",
	"./steam.svg": "3a1f",
	"./switch.svg": "35f4",
	"./ubisoft.svg": "3fc5",
	"./uplay.svg": "b13d",
	"./xbox.svg": "6219"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0475";